import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { Terminal, ShoppingCart } from "lucide-react";
import { homePathForRole } from "@/lib/authRouting";

export default function PublicNav() {
  const { user } = useAuth();
  const { count } = useCart();
  const linkCls = ({ isActive }) =>
    `px-3 py-2 text-sm font-medium transition-colors ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`;

  return (
    <header
      data-testid="public-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#09090B]/80 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <div className="h-8 w-8 flex items-center justify-center border border-white/20 group-hover:border-white transition-colors">
            <Terminal className="h-4 w-4" strokeWidth={2} />
          </div>
          <span className="font-heading font-black tracking-tighter text-lg">Flix VPS</span>
        </Link>
        <nav className="hidden md:flex items-center gap-2">
          <a href="/#planos" className={linkCls({ isActive: false })} data-testid="nav-planos">Planos</a>
          <a href="/#features" className={linkCls({ isActive: false })} data-testid="nav-features">Features</a>
          <a href="/#faq" className={linkCls({ isActive: false })} data-testid="nav-faq">FAQ</a>
          <NavLink to="/login" className={linkCls} data-testid="nav-login">Entrar</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/cart" className="relative p-2 text-zinc-400 hover:text-white transition-colors" data-testid="nav-cart-btn" aria-label="Carrinho">
            <ShoppingCart className="h-5 w-5" />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] flex items-center justify-center px-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-[10px] font-bold rounded-full">{count}</span>
            )}
          </Link>
          {user ? (
            <Button asChild className="rounded-sm bg-white text-black hover:bg-zinc-200" data-testid="nav-dashboard-btn">
              <Link to={homePathForRole(user.role)}>Painel</Link>
            </Button>
          ) : (
            <Button asChild className="rounded-sm bg-white text-black hover:bg-zinc-200" data-testid="nav-register-btn">
              <Link to="/register">Começar</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
